module.exports = __webpack_public_path__ + "static/media/19ESCAP7.052538cf.jpg";